import React from 'react'
import { useSelector } from 'react-redux'

export default function SectionPreview() {
  const pages = useSelector(({ pages }) => pages.all)

  return (
    <div
      style={{
        height: 810,
        overflow: 'auto',
        flexBasis: '35%',
        background: '#DBDBDB',
        borderLeft: '1px solid var(--accent, #F0F0F0)',
        borderRight: '1px solid var(--accent, #F0F0F0)',
        padding: 35,
      }}
    >
      <div className="dome-d-flex dome-flex-column dome-gap40">
        {pages.map((page) => (
          <div key={page.id} className="thumbnail-container">
            <img className="img-thumbnail" src={page.url} alt={`page-${page.id}`} />
          </div>
        ))}
      </div>
    </div>
  )
}
